import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=b6d50d42&scoped=true&"
import script from "./Stars.vue?vue&type=script&lang=js&"
export * from "./Stars.vue?vue&type=script&lang=js&"
import style0 from "./Stars.vue?vue&type=style&index=0&id=b6d50d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d50d42",
  null
  
)

export default component.exports